import * as React from "react";
import styled from "styled-components";
import L, { LeafletEventHandlerFn } from "leaflet";
import { useEffect, useRef, useState } from "react";
import * as geolib from "geolib";
import { useQuery, useSubscription } from "urql";
import gql from "graphql-tag";
import extendHeatlayer from "./extensionHeatlayer";
extendHeatlayer(); //Installs heatmap extension onto Leaflet

const SAMPLE_HEAT_DATA = [
  [6.731904745101929, 51.26191485308451],
  [6.731936931610107, 51.261854429833235],
  [6.732044219970703, 51.26180072020985],
  [6.7321085929870605, 51.26189471200958],
  [6.73199325799942, 51.26189303358627],
  [6.73199325799942, 51.26185946510721],
  [6.732036173343658, 51.26185946510721],
  [6.732116639614105, 51.261830931880716],
  [6.732116639614105, 51.26176547323539],
  [6.7320603132247925, 51.26175036738093],
  [6.7319610714912415, 51.261767151663356],
  [6.731904745101929, 51.26179736335631],
  [6.731934249401092, 51.26179736335631],
  [6.731979846954346, 51.26179736335631],
  [6.7319852113723755, 51.2617805790849],
  [6.732020080089569, 51.261738618379596],
  [6.7320388555526725, 51.26173022623391],
  [6.732154190540314, 51.26173022623391],
  [6.732172966003418, 51.261785614366964],
  [6.732172966003418, 51.26181918289997],
  [6.732172966003418, 51.26183428873181],
  [6.732172966003418, 51.2618695356535],
  [6.732140779495238, 51.26186282195622],
  [6.732095181941986, 51.261842680858464],
  [6.732095181941986, 51.26180911234263],
  [6.732071042060852, 51.26179568492944],
  [6.732036173343658, 51.26177890065744],
  [6.731926202774048, 51.261839324008],
  [6.731848418712616, 51.261842680858464],
  [6.731848418712616, 51.26194338625892],
  [6.732012033462524, 51.261981989937254],
  [6.732092499732971, 51.26197527625638],
  [6.73199325799942, 51.261934994150636],
  [6.731918156147003, 51.26193835099413],
  [6.731918156147003, 51.26203066409415],
  [6.732062995433807, 51.26203066409415],
  [6.732191741466522, 51.26200716623173],
  [6.732148826122284, 51.26195177836567],
  [6.732368767261505, 51.262017236745656],
  [6.732282936573028, 51.261970240995105],
  [6.73225075006485, 51.261960170470864],
  [6.732242703437804, 51.26202395042037],
  [6.732272207736969, 51.26205751877934],
  [6.732127368450165, 51.262069267699175],
  [6.732095181941986, 51.26205584036196],
  [6.732044219970703, 51.262092765529836],
  [6.73213005065918, 51.26211626334849],
  [6.732197105884552, 51.26213472591187],
  [6.732261478900909, 51.26210954968726],
  [6.73237144947052, 51.262106192856265],
  [6.732366085052489, 51.262040734602934],
  [6.732478737831116, 51.26204744827422],
  [6.732470691204071, 51.26217668625561],
  [6.732411682605743, 51.26214479639786],
  [6.732304394245147, 51.26216158053625],
  [6.732465326786041, 51.26228578296999],
  [6.73259139060974, 51.262257250008176],
  [6.732505559921265, 51.262198505619196],
  [6.7325833439826965, 51.26211962017875],
  [6.732693314552306, 51.26222536020633],
  [6.732599437236786, 51.26238648739964],
  [6.73249751329422, 51.262347884061036],
  [6.732760369777679, 51.26233109999066],
  [6.732728183269501, 51.26230424546531],
  [6.732741594314575, 51.262257250008176],
  [6.732843518257141, 51.262213611326366],
  [6.7327362298965445, 51.26211962017875],
  [6.732634305953979, 51.262101157609315],
  [6.732596755027771, 51.26205751877934],
  [6.732529699802398, 51.262010523069954],
  [6.732328534126282, 51.26194338625892],
  [6.732269525527954, 51.26191317466194],
  [6.732146143913269, 51.26191317466194],
  [6.732076406478882, 51.26192660204084],
  [6.732800602912903, 51.26246369397961],
  [6.732915937900543, 51.26233109999066],
  [6.732972264289856, 51.26233109999066],
  [6.7328327894210815, 51.262279069333545],
  [6.732779145240784, 51.26226060682813],
  [6.732873022556305, 51.26242005549383],
  [6.732653081417083, 51.26240159304505],
  [6.732728183269501, 51.26234620565427],
  [6.73287034034729, 51.26246033717447],
  [6.732720136642456, 51.262498940418645],
  [6.732720136642456, 51.262462015577064],
  [6.732867658138275, 51.26254929242752],
  [6.732881069183349, 51.26250565402303],
  [6.7329347133636475, 51.26241837708968],
  [6.733036637306213, 51.262368024937395],
  [6.733141243457794, 51.26238480899429],
  [6.733278036117554, 51.262356276093925],
  [6.733216345310211, 51.262517402828315],
  [6.7331841588020325, 51.26249390521472],
  [6.7331573367118835, 51.262428447513535],
  [6.732902526855469, 51.2624351611282],
  [6.733087599277496, 51.26254593562866],
  [6.733087599277496, 51.2624485883546],
  [6.733396053314209, 51.262441874741896],
  [6.7335328459739685, 51.262391522615346],
  [6.7333075404167175, 51.262351240874374],
  [6.7333075404167175, 51.26252243802967],
  [6.733178794384003, 51.26258286040281],
  [6.733015179634094, 51.26257111161424],
  [6.732988357543945, 51.26252075962926],
  [6.733210980892181, 51.262300888648504],
  [6.733342409133911, 51.262300888648504],
  [6.733455061912536, 51.262337813619546],
  [6.733535528182983, 51.26234452724744],
  [6.733452379703522, 51.26222368179508],
  [6.732229292392731, 51.26189303358627],
  [6.732229292392731, 51.26182086132597],
  [6.732229292392731, 51.261767151663356],
  [6.732223927974701, 51.26172519094579],
  [6.73212468624115, 51.26169497920541],
  [6.732100546360015, 51.26169497920541],
  [6.73199862241745, 51.26169497920541],
  [6.731971800327301, 51.2617218340867],
  [6.732301712036133, 51.261864500380646],
  [6.732304394245147, 51.26182757502939],
  [6.732296347618103, 51.26179568492944],
  [6.732438504695892, 51.261792328075515],
  [6.732269525527954, 51.26176043795111],
  [6.7322856187820435, 51.2617537242379],
  [6.732221245765685, 51.261661410581716],
  [6.7321354150772095, 51.261661410581716],
  [6.732105910778046, 51.261661410581716],
  [6.733176112174988, 51.2626097147654],
  [6.733278036117554, 51.2625727900128],
  [6.733240485191345, 51.262478799599634],
  [6.733052730560303, 51.262462015577064],
  [6.732805967330933, 51.262462015577064],
  [6.732993721961975, 51.262579503606396],
  [6.733079552650452, 51.26254593562866],
  [6.733192205429077, 51.262472085991355],
  [6.733074188232422, 51.26238816580493],
  [6.732827425003052, 51.26233445680519],
  [6.732757687568664, 51.26240159304505],
  [6.732966899871826, 51.262441874741896],
  [6.732977628707886, 51.2625325084307],
  [6.732800602912903, 51.2625325084307],
  [6.732671856880188, 51.262462015577064],
  [6.73262894153595, 51.2623814521834],
  [6.732854247093201, 51.262337813619546],
  [6.732757687568664, 51.262237109083266],
  [6.732489466667174, 51.262267320467295],
  [6.732419729232788, 51.26232102954548],
  [6.732543110847473, 51.262431804321],
  [6.732553839683533, 51.26233445680519],
  [6.732575297355652, 51.2622505363675],
  [6.732451915740967, 51.26216325894976],
  [6.732473373413086, 51.26205584036196],
  [6.732666492462158, 51.26216325894976],
  [6.732349991798401, 51.262200184031336],
  [6.732253432273865, 51.262146474811956],
  [6.732269525527954, 51.26205248352704],
  [6.732081770896912, 51.26198870361711],
  [6.732054948806763, 51.26210954968726],
  [6.732189059257507, 51.262216968149524],
  [6.7323607206344604, 51.26228410456098],
  [6.73237681388855, 51.26208269503245],
  [6.732296347618103, 51.261971919415586],
  [6.732076406478882, 51.26192492361867],
  [6.731840372085571, 51.262008844650865],
  [6.731743812561035, 51.261908139393846],
  [6.731727719306945, 51.26179400650252],
  [6.731931567192078, 51.261773865374636],
  [6.731931567192078, 51.26187457092582],
  [6.731824278831482, 51.26189806885602],
  [6.731899380683899, 51.26201555832683],
  [6.731942296028137, 51.262146474811956],
  [6.7321354150772095, 51.26203234251242],
  [6.732242703437804, 51.261931637306894],
  [6.7324841022491455, 51.2619920604567],
  [6.732682585716248, 51.26212969066805],
  [6.732886433601379, 51.26229081819674],
  [6.733079552650452, 51.262354597687455],
  [6.733031272888184, 51.26226060682813],
  [6.732918620109558, 51.26224717954681],
  [6.732854247093201, 51.26223375226158],
  [6.732891798019409, 51.26224717954681],
].map(v => ({ lat: v[0], lon: v[1], value: 0.8 + Math.random() * 0.2 }));

//START
/*
 * 🍂class ImageOverlay.Rotated
 * 🍂inherits ImageOverlay
 *
 * Like `ImageOverlay`, but rotates and skews the image. This is done by using
 * *three* control points instead of *two*.
 *
 * @example
 *
 * ```
 * var topleft    = L.latLng(40.52256691873593, -3.7743186950683594),
 * 	topright   = L.latLng(40.5210255066156, -3.7734764814376835),
 * 	bottomleft = L.latLng(40.52180437272552, -3.7768453359603886);
 *
 * var overlay = L.imageOverlay.rotated("./palacio.jpg", topleft, topright, bottomleft, {
 * 	opacity: 0.4,
 * 	interactive: true,
 * 	attribution: "&copy; <a href='http://www.ign.es'>Instituto Geográfico Nacional de España</a>"
 * });
 * ```
 *
 */

//@ts-ignore
L.ImageOverlay.Rotated = L.ImageOverlay.extend({
  //@ts-ignore
  initialize: function(image, topleft, topright, bottomleft, options) {
    if (typeof image === "string") {
      this._url = image;
    } else {
      // Assume that the first parameter is an instance of HTMLImage or HTMLCanvas
      this._rawImage = image;
    }

    this._topLeft = L.latLng(topleft);
    this._topRight = L.latLng(topright);
    this._bottomLeft = L.latLng(bottomleft);

    //@ts-ignore
    L.setOptions(this, options);
  },

  onAdd: function(map: any) {
    if (!this._image) {
      this._initImage();

      if (this.options.opacity < 1) {
        this._updateOpacity();
      }
    }

    if (this.options.interactive) {
      L.DomUtil.addClass(this._rawImage, "leaflet-interactive");
      this.addInteractiveTarget(this._rawImage);
    }

    map.on("zoomend resetview", this._reset, this);

    this.getPane().appendChild(this._image);
    this._reset();
  },

  onRemove: function(map: any) {
    map.off("zoomend resetview", this._reset, this);
    L.ImageOverlay.prototype.onRemove.call(this, map);
  },

  _initImage: function() {
    var img = this._rawImage;
    if (this._url) {
      img = L.DomUtil.create("img");
      img.style.display = "none"; // Hide while the first transform (zero or one frames) is being done

      if (this.options.crossOrigin) {
        img.crossOrigin = "";
      }

      img.src = this._url;
      this._rawImage = img;
    }
    L.DomUtil.addClass(img, "leaflet-image-layer");

    // this._image is reused by some of the methods of the parent class and
    // must keep the name, even if it is counter-intuitive.
    var div = (this._image = L.DomUtil.create(
      "div",
      "leaflet-image-layer " +
        (this._zoomAnimated ? "leaflet-zoom-animated" : "")
    ));

    this._updateZIndex(); // apply z-index style setting to the div (if defined)

    div.appendChild(img);

    div.onselectstart = L.Util.falseFn;
    div.onmousemove = L.Util.falseFn;

    img.onload = function() {
      //@ts-ignore
      this._reset();
      img.style.display = "block";
      //@ts-ignore
      this.fire("load");
    }.bind(this);

    img.alt = this.options.alt;
  },

  _reset: function() {
    var div = this._image;

    if (!this._map) {
      return;
    }

    // Project control points to container-pixel coordinates
    var pxTopLeft = this._map.latLngToLayerPoint(this._topLeft);
    var pxTopRight = this._map.latLngToLayerPoint(this._topRight);
    var pxBottomLeft = this._map.latLngToLayerPoint(this._bottomLeft);

    // Infer coordinate of bottom right
    var pxBottomRight = pxTopRight.subtract(pxTopLeft).add(pxBottomLeft);

    // pxBounds is mostly for positioning the <div> container
    var pxBounds = L.bounds([
      pxTopLeft,
      pxTopRight,
      pxBottomLeft,
      pxBottomRight,
    ]);
    var size = pxBounds.getSize();
    var pxTopLeftInDiv = pxTopLeft.subtract(pxBounds.min);

    // LatLngBounds are needed for (zoom) animations
    this._bounds = L.latLngBounds(
      this._map.layerPointToLatLng(pxBounds.min),
      this._map.layerPointToLatLng(pxBounds.max)
    );

    L.DomUtil.setPosition(div, pxBounds.min!);

    div.style.width = size.x + "px";
    div.style.height = size.y + "px";

    var imgW = this._rawImage.width;
    var imgH = this._rawImage.height;
    if (!imgW || !imgH) {
      return; // Probably because the image hasn't loaded yet.
    }

    // Sides of the control-point box, in pixels
    // These are the main ingredient for the transformation matrix.
    var vectorX = pxTopRight.subtract(pxTopLeft);
    var vectorY = pxBottomLeft.subtract(pxTopLeft);

    this._rawImage.style.transformOrigin = "0 0";

    // The transformation is an affine matrix that switches
    // coordinates around in just the right way. This is the result
    // of calculating the skew/rotation/scale matrices and simplyfing
    // everything.
    this._rawImage.style.transform =
      "matrix(" +
      vectorX.x / imgW +
      ", " +
      vectorX.y / imgW +
      ", " +
      vectorY.x / imgH +
      ", " +
      vectorY.y / imgH +
      ", " +
      pxTopLeftInDiv.x +
      ", " +
      pxTopLeftInDiv.y +
      ")";
  },

  //@ts-ignore
  reposition: function(topleft, topright, bottomleft) {
    this._topLeft = L.latLng(topleft);
    this._topRight = L.latLng(topright);
    this._bottomLeft = L.latLng(bottomleft);
    this._reset();
  },

  setUrl: function(url: any) {
    this._url = url;

    if (this._rawImage) {
      this._rawImage.src = url;
    }
    return this;
  },
});

/* 🍂factory imageOverlay.rotated(imageUrl: String|HTMLImageElement|HTMLCanvasElement, topleft: LatLng, topright: LatLng, bottomleft: LatLng, options?: ImageOverlay options)
 * Instantiates a rotated/skewed image overlay, given the image URL and
 * the `LatLng`s of three of its corners.
 *
 * Alternatively to specifying the URL of the image, an existing instance of `HTMLImageElement`
 * or `HTMLCanvasElement` can be used.
 */
L.imageOverlay.rotated = function(
  imgSrc,
  topleft,
  topright,
  bottomleft,
  options
) {
  //@ts-ignore
  return new L.ImageOverlay.Rotated(
    imgSrc,
    topleft,
    topright,
    bottomleft,
    options
  );
};

//END

const STADIUM: [number, number] = [51.261815, 6.733132];
const STADIUM_MASK = {
  type: "Feature",
  properties: {},
  geometry: {
    type: "Polygon",
    coordinates: [
      [
        [6.730923056602478, 51.261908139393846],
        [6.7331331968307495, 51.26021290111711],
        [6.735386252403258, 51.26134754276384],
        [6.733160018920898, 51.26306623652867],
        [6.730923056602478, 51.261908139393846],
      ],
    ],
  },
};
const STADIUM_BEARING_X = geolib.getRhumbLineBearing(
  [6.730923056602478, 51.261908139393846],
  [6.733160018920898, 51.26306623652867]
);
const STADIUM_BEARING_Y = geolib.getRhumbLineBearing(
  [6.730923056602478, 51.261908139393846],
  [6.7331331968307495, 51.26021290111711]
);
console.log(STADIUM_BEARING_X);
console.log(STADIUM_BEARING_Y);
const STADIUM_DISTANCE_X = geolib.getDistance(
  [6.730923056602478, 51.261908139393846],
  [6.733160018920898, 51.26306623652867],
  0.01
);
const STADIUM_DISTANCE_Y = geolib.getDistance(
  [6.730923056602478, 51.261908139393846],
  [6.7331331968307495, 51.26021290111711],
  0.01
);
console.log(STADIUM_DISTANCE_X);
console.log(STADIUM_DISTANCE_Y);

type HeatmapValue = { lat: number; lon: number; value: number };

const loadHeatmapValues = (map: L.Map, values?: HeatmapValue[]) => {
  console.log("loading values");

  //If there are values lets draw in the heatmap
  if (values && Array.isArray(values)) {
    const heatValues = values.map(v => [v.lon, v.lat, v.value]);
    console.log(heatValues);
    //@ts-ignore
    const heat = L.heatLayer(heatValues, { radius: 10 }).addTo(map);
  }
};

const drawMap = (element: HTMLElement): L.Map => {
  //Create map
  const id = element.id;
  const map = L.map(id).setView(L.latLng(STADIUM), 17);

  //ADD IMAGE OVERLAY
  const topleft: [number, number] = [51.261908139393846, 6.730923056602478];
  const topright: [number, number] = [51.26306623652867, 6.733160018920898];
  const bottomleft: [number, number] = [51.26021290111711, 6.7331331968307495];
  //   const topleft: [number, number] = [6.730923056602478, 51.261908139393846];
  //   const topright: [number, number] = [6.733160018920898, 51.26306623652867];
  //   const bottomleft: [number, number] = [6.7331331968307495, 51.26021290111711];

  const bounds = new L.LatLngBounds(topleft, topright).extend(bottomleft);
  map.fitBounds(bounds);

  const overlay = L.imageOverlay
    .rotated("images/dcm_stadium.jpg", topleft, topright, bottomleft, {
      opacity: 0.65,
      interactive: true,
      attribution: "Merkur Spiel-Arena",
    })
    .addTo(map);

  const style = {
    color: "#000",
    weight: 1,
    opacity: 0.05,
  };

  const geoJSONFeature = {
    type: "FeatureCollection",
    features: [
      {
        type: "Feature",
        properties: {},
        geometry: {
          type: "Polygon",
          coordinates: [
            [
              [6.730923056602478, 51.261908139393846],
              [6.7331331968307495, 51.26021290111711],
              [6.735386252403258, 51.26134754276384],
              [6.733160018920898, 51.26306623652867],
              [6.730923056602478, 51.261908139393846],
            ],
          ],
        },
      },
    ],
  };

  //Draw tile layer
  L.tileLayer(
    "https://api.tiles.mapbox.com/v4/{id}/{z}/{x}/{y}.png?access_token={accessToken}",
    {
      attribution:
        'Map data &copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors, <a href="https://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>, Imagery © <a href="https://www.mapbox.com/">Mapbox</a>',
      maxZoom: 20,
      id: "mapbox.streets",
      accessToken:
        "pk.eyJ1IjoidmNoYW5hY2VzIiwiYSI6ImNqenVpYzd2ODAwem0zY3FpZTl4MDFndzUifQ.UZL1LZPEvITFrB1Fx6m1rQ",
    }
  ).addTo(map);

  // L.geoJson(geoJSONFeature, { style: () => style }).addTo(map);

  const greenIcon = L.icon({
    iconUrl: "leaf-green.png",
    shadowUrl: "leaf-shadow.png",

    iconSize: [38, 95], // size of the icon
    shadowSize: [50, 64], // size of the shadow
    iconAnchor: [22, 94], // point of the icon which will correspond to marker's location
    shadowAnchor: [4, 62], // the same for the shadow
    popupAnchor: [0, -76], // point from which the popup should open relative to the iconAnchor
  });

  const marker = L.marker([6.7331331968307495, 51.26021290111711], {
    zIndexOffset: 9999,
    opacity: 1,
    icon: greenIcon,
  }).addTo(map);
  const circle = L.circle([-33.8591, 151.2002], 500, {
    color: "red",
    fillColor: "#f03",
    fillOpacity: 0.5,
  }).addTo(map);
  const polygon = L.polygon(
    [[-33.7591, 151.1002], [-33.6591, 151.7002], [-33.5591, 151.3002]],
    { fillColor: "#070" }
  ).addTo(map);

  //   marker.bindPopup("<b>Hello world!</b><br>I am a popup.").openPopup();
  //   circle.bindPopup("I am a circle.");
  //   polygon.bindPopup("I am a polygon.");

  //   const popup = L.popup()
  //     .setLatLng([-33.8591, 151.2092])
  //     .setContent("I am a standalone popup.")
  //     .openOn(map);

  //Events
  const popup2 = L.popup();
  // function onMapClick(e: L.LeafletMouseEvent) {
  //   popup2
  //     .setLatLng(e.latlng)
  //     .setContent("You clicked the map at " + e.latlng.toString())
  //     .openOn(map);
  // }

  // map.on("click", onMapClick as LeafletEventHandlerFn);

  return map;
};

const StyledSection = styled.section`
  /* Leaflet required css */
  /* required styles */

  .leaflet-pane,
  .leaflet-tile,
  .leaflet-marker-icon,
  .leaflet-marker-shadow,
  .leaflet-tile-container,
  .leaflet-pane > svg,
  .leaflet-pane > canvas,
  .leaflet-zoom-box,
  .leaflet-image-layer,
  .leaflet-layer {
    position: absolute;
    left: 0;
    top: 0;
  }
  .leaflet-container {
    overflow: hidden;
  }
  .leaflet-tile,
  .leaflet-marker-icon,
  .leaflet-marker-shadow {
    -webkit-user-select: none;
    -moz-user-select: none;
    user-select: none;
    -webkit-user-drag: none;
  }
  /* Prevents IE11 from highlighting tiles in blue */
  .leaflet-tile::selection {
    background: transparent;
  }
  /* Safari renders non-retina tile on retina better with this, but Chrome is worse */
  .leaflet-safari .leaflet-tile {
    image-rendering: -webkit-optimize-contrast;
  }
  /* hack that prevents hw layers "stretching" when loading new tiles */
  .leaflet-safari .leaflet-tile-container {
    width: 1600px;
    height: 1600px;
    -webkit-transform-origin: 0 0;
  }
  .leaflet-marker-icon,
  .leaflet-marker-shadow {
    display: block;
  }
  /* .leaflet-container svg: reset svg max-width decleration shipped in Joomla! (joomla.org) 3.x */
  /* .leaflet-container img: map is broken in FF if you have max-width: 100% on tiles */
  .leaflet-container .leaflet-overlay-pane svg,
  .leaflet-container .leaflet-marker-pane img,
  .leaflet-container .leaflet-shadow-pane img,
  .leaflet-container .leaflet-tile-pane img,
  .leaflet-container img.leaflet-image-layer,
  .leaflet-container .leaflet-tile {
    max-width: none !important;
    max-height: none !important;
  }

  .leaflet-container.leaflet-touch-zoom {
    -ms-touch-action: pan-x pan-y;
    touch-action: pan-x pan-y;
  }
  .leaflet-container.leaflet-touch-drag {
    -ms-touch-action: pinch-zoom;
    /* Fallback for FF which doesn't support pinch-zoom */
    touch-action: none;
    touch-action: pinch-zoom;
  }
  .leaflet-container.leaflet-touch-drag.leaflet-touch-zoom {
    -ms-touch-action: none;
    touch-action: none;
  }
  .leaflet-container {
    -webkit-tap-highlight-color: transparent;
  }
  .leaflet-container a {
    -webkit-tap-highlight-color: rgba(51, 181, 229, 0.4);
  }
  .leaflet-tile {
    filter: inherit;
    visibility: hidden;
  }
  .leaflet-tile-loaded {
    visibility: inherit;
  }
  .leaflet-zoom-box {
    width: 0;
    height: 0;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    z-index: 800;
  }
  /* workaround for https://bugzilla.mozilla.org/show_bug.cgi?id=888319 */
  .leaflet-overlay-pane svg {
    -moz-user-select: none;
  }

  .leaflet-pane {
    z-index: 400;
  }

  .leaflet-tile-pane {
    z-index: 200;
  }
  .leaflet-overlay-pane {
    z-index: 400;
  }
  .leaflet-shadow-pane {
    z-index: 500;
  }
  .leaflet-marker-pane {
    z-index: 600;
  }
  .leaflet-tooltip-pane {
    z-index: 650;
  }
  .leaflet-popup-pane {
    z-index: 700;
  }

  .leaflet-map-pane canvas {
    z-index: 100;
  }
  .leaflet-map-pane svg {
    z-index: 200;
  }

  .leaflet-vml-shape {
    width: 1px;
    height: 1px;
  }
  .lvml {
    behavior: url(#default#VML);
    display: inline-block;
    position: absolute;
  }

  /* control positioning */

  .leaflet-control {
    position: relative;
    z-index: 800;
    pointer-events: visiblePainted; /* IE 9-10 doesn't have auto */
    pointer-events: auto;
  }
  .leaflet-top,
  .leaflet-bottom {
    position: absolute;
    z-index: 1000;
    pointer-events: none;
  }
  .leaflet-top {
    top: 0;
  }
  .leaflet-right {
    right: 0;
  }
  .leaflet-bottom {
    bottom: 0;
  }
  .leaflet-left {
    left: 0;
  }
  .leaflet-control {
    float: left;
    clear: both;
  }
  .leaflet-right .leaflet-control {
    float: right;
  }
  .leaflet-top .leaflet-control {
    margin-top: 10px;
  }
  .leaflet-bottom .leaflet-control {
    margin-bottom: 10px;
  }
  .leaflet-left .leaflet-control {
    margin-left: 10px;
  }
  .leaflet-right .leaflet-control {
    margin-right: 10px;
  }

  /* zoom and fade animations */

  .leaflet-fade-anim .leaflet-tile {
    will-change: opacity;
  }
  .leaflet-fade-anim .leaflet-popup {
    opacity: 0;
    -webkit-transition: opacity 0.2s linear;
    -moz-transition: opacity 0.2s linear;
    transition: opacity 0.2s linear;
  }
  .leaflet-fade-anim .leaflet-map-pane .leaflet-popup {
    opacity: 1;
  }
  .leaflet-zoom-animated {
    -webkit-transform-origin: 0 0;
    -ms-transform-origin: 0 0;
    transform-origin: 0 0;
  }
  .leaflet-zoom-anim .leaflet-zoom-animated {
    will-change: transform;
  }
  .leaflet-zoom-anim .leaflet-zoom-animated {
    -webkit-transition: -webkit-transform 0.25s cubic-bezier(0, 0, 0.25, 1);
    -moz-transition: -moz-transform 0.25s cubic-bezier(0, 0, 0.25, 1);
    transition: transform 0.25s cubic-bezier(0, 0, 0.25, 1);
  }
  .leaflet-zoom-anim .leaflet-tile,
  .leaflet-pan-anim .leaflet-tile {
    -webkit-transition: none;
    -moz-transition: none;
    transition: none;
  }

  .leaflet-zoom-anim .leaflet-zoom-hide {
    visibility: hidden;
  }

  /* cursors */

  .leaflet-interactive {
    cursor: pointer;
  }
  .leaflet-grab {
    cursor: -webkit-grab;
    cursor: -moz-grab;
    cursor: grab;
  }
  .leaflet-crosshair,
  .leaflet-crosshair .leaflet-interactive {
    cursor: crosshair;
  }
  .leaflet-popup-pane,
  .leaflet-control {
    cursor: auto;
  }
  .leaflet-dragging .leaflet-grab,
  .leaflet-dragging .leaflet-grab .leaflet-interactive,
  .leaflet-dragging .leaflet-marker-draggable {
    cursor: move;
    cursor: -webkit-grabbing;
    cursor: -moz-grabbing;
    cursor: grabbing;
  }

  /* marker & overlays interactivity */
  .leaflet-marker-icon,
  .leaflet-marker-shadow,
  .leaflet-image-layer,
  .leaflet-pane > svg path,
  .leaflet-tile-container {
    pointer-events: none;
  }

  .leaflet-marker-icon.leaflet-interactive,
  .leaflet-image-layer.leaflet-interactive,
  .leaflet-pane > svg path.leaflet-interactive,
  svg.leaflet-image-layer.leaflet-interactive path {
    pointer-events: visiblePainted; /* IE 9-10 doesn't have auto */
    pointer-events: auto;
  }

  /* visual tweaks */

  .leaflet-container {
    background: #ddd;
    outline: 0;
  }
  .leaflet-container a {
    color: #0078a8;
  }
  .leaflet-container a.leaflet-active {
    outline: 2px solid orange;
  }
  .leaflet-zoom-box {
    border: 2px dotted #38f;
    background: rgba(255, 255, 255, 0.5);
  }

  /* general typography */
  .leaflet-container {
    font: 12px/1.5 "Helvetica Neue", Arial, Helvetica, sans-serif;
  }

  /* general toolbar styles */

  .leaflet-bar {
    box-shadow: 0 1px 5px rgba(0, 0, 0, 0.65);
    border-radius: 4px;
  }
  .leaflet-bar a,
  .leaflet-bar a:hover {
    background-color: #fff;
    border-bottom: 1px solid #ccc;
    width: 26px;
    height: 26px;
    line-height: 26px;
    display: block;
    text-align: center;
    text-decoration: none;
    color: black;
  }
  .leaflet-bar a,
  .leaflet-control-layers-toggle {
    background-position: 50% 50%;
    background-repeat: no-repeat;
    display: block;
  }
  .leaflet-bar a:hover {
    background-color: #f4f4f4;
  }
  .leaflet-bar a:first-child {
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
  }
  .leaflet-bar a:last-child {
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
    border-bottom: none;
  }
  .leaflet-bar a.leaflet-disabled {
    cursor: default;
    background-color: #f4f4f4;
    color: #bbb;
  }

  .leaflet-touch .leaflet-bar a {
    width: 30px;
    height: 30px;
    line-height: 30px;
  }
  .leaflet-touch .leaflet-bar a:first-child {
    border-top-left-radius: 2px;
    border-top-right-radius: 2px;
  }
  .leaflet-touch .leaflet-bar a:last-child {
    border-bottom-left-radius: 2px;
    border-bottom-right-radius: 2px;
  }

  /* zoom control */

  .leaflet-control-zoom-in,
  .leaflet-control-zoom-out {
    font: bold 18px "Lucida Console", Monaco, monospace;
    text-indent: 1px;
  }

  .leaflet-touch .leaflet-control-zoom-in,
  .leaflet-touch .leaflet-control-zoom-out {
    font-size: 22px;
  }

  /* layers control */

  .leaflet-control-layers {
    box-shadow: 0 1px 5px rgba(0, 0, 0, 0.4);
    background: #fff;
    border-radius: 5px;
  }
  .leaflet-control-layers-toggle {
    background-image: url(images/layers.png);
    width: 36px;
    height: 36px;
  }
  .leaflet-retina .leaflet-control-layers-toggle {
    background-image: url(images/layers-2x.png);
    background-size: 26px 26px;
  }
  .leaflet-touch .leaflet-control-layers-toggle {
    width: 44px;
    height: 44px;
  }
  .leaflet-control-layers .leaflet-control-layers-list,
  .leaflet-control-layers-expanded .leaflet-control-layers-toggle {
    display: none;
  }
  .leaflet-control-layers-expanded .leaflet-control-layers-list {
    display: block;
    position: relative;
  }
  .leaflet-control-layers-expanded {
    padding: 6px 10px 6px 6px;
    color: #333;
    background: #fff;
  }
  .leaflet-control-layers-scrollbar {
    overflow-y: scroll;
    overflow-x: hidden;
    padding-right: 5px;
  }
  .leaflet-control-layers-selector {
    margin-top: 2px;
    position: relative;
    top: 1px;
  }
  .leaflet-control-layers label {
    display: block;
  }
  .leaflet-control-layers-separator {
    height: 0;
    border-top: 1px solid #ddd;
    margin: 5px -10px 5px -6px;
  }

  /* Default icon URLs */
  .leaflet-default-icon-path {
    background-image: url(images/marker-icon.png);
  }

  /* attribution and scale controls */

  .leaflet-container .leaflet-control-attribution {
    background: #fff;
    background: rgba(255, 255, 255, 0.7);
    margin: 0;
  }
  .leaflet-control-attribution,
  .leaflet-control-scale-line {
    padding: 0 5px;
    color: #333;
  }
  .leaflet-control-attribution a {
    text-decoration: none;
  }
  .leaflet-control-attribution a:hover {
    text-decoration: underline;
  }
  .leaflet-container .leaflet-control-attribution,
  .leaflet-container .leaflet-control-scale {
    font-size: 11px;
  }
  .leaflet-left .leaflet-control-scale {
    margin-left: 5px;
  }
  .leaflet-bottom .leaflet-control-scale {
    margin-bottom: 5px;
  }
  .leaflet-control-scale-line {
    border: 2px solid #777;
    border-top: none;
    line-height: 1.1;
    padding: 2px 5px 1px;
    font-size: 11px;
    white-space: nowrap;
    overflow: hidden;
    -moz-box-sizing: border-box;
    box-sizing: border-box;

    background: #fff;
    background: rgba(255, 255, 255, 0.5);
  }
  .leaflet-control-scale-line:not(:first-child) {
    border-top: 2px solid #777;
    border-bottom: none;
    margin-top: -2px;
  }
  .leaflet-control-scale-line:not(:first-child):not(:last-child) {
    border-bottom: 2px solid #777;
  }

  .leaflet-touch .leaflet-control-attribution,
  .leaflet-touch .leaflet-control-layers,
  .leaflet-touch .leaflet-bar {
    box-shadow: none;
  }
  .leaflet-touch .leaflet-control-layers,
  .leaflet-touch .leaflet-bar {
    border: 2px solid rgba(0, 0, 0, 0.2);
    background-clip: padding-box;
  }

  /* popup */

  .leaflet-popup {
    position: absolute;
    text-align: center;
    margin-bottom: 20px;
  }
  .leaflet-popup-content-wrapper {
    padding: 1px;
    text-align: left;
    border-radius: 12px;
  }
  .leaflet-popup-content {
    margin: 13px 19px;
    line-height: 1.4;
  }
  .leaflet-popup-content p {
    margin: 18px 0;
  }
  .leaflet-popup-tip-container {
    width: 40px;
    height: 20px;
    position: absolute;
    left: 50%;
    margin-left: -20px;
    overflow: hidden;
    pointer-events: none;
  }
  .leaflet-popup-tip {
    width: 17px;
    height: 17px;
    padding: 1px;

    margin: -10px auto 0;

    -webkit-transform: rotate(45deg);
    -moz-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(45deg);
  }
  .leaflet-popup-content-wrapper,
  .leaflet-popup-tip {
    background: white;
    color: #333;
    box-shadow: 0 3px 14px rgba(0, 0, 0, 0.4);
  }
  .leaflet-container a.leaflet-popup-close-button {
    position: absolute;
    top: 0;
    right: 0;
    padding: 4px 4px 0 0;
    border: none;
    text-align: center;
    width: 18px;
    height: 14px;
    font: 16px/14px Tahoma, Verdana, sans-serif;
    color: #c3c3c3;
    text-decoration: none;
    font-weight: bold;
    background: transparent;
  }
  .leaflet-container a.leaflet-popup-close-button:hover {
    color: #999;
  }
  .leaflet-popup-scrolled {
    overflow: auto;
    border-bottom: 1px solid #ddd;
    border-top: 1px solid #ddd;
  }

  .leaflet-oldie .leaflet-popup-content-wrapper {
    zoom: 1;
  }
  .leaflet-oldie .leaflet-popup-tip {
    width: 24px;
    margin: 0 auto;

    -ms-filter: "progid:DXImageTransform.Microsoft.Matrix(M11=0.70710678, M12=0.70710678, M21=-0.70710678, M22=0.70710678)";
    filter: progid:DXImageTransform.Microsoft.Matrix(M11=0.70710678, M12=0.70710678, M21=-0.70710678, M22=0.70710678);
  }
  .leaflet-oldie .leaflet-popup-tip-container {
    margin-top: -1px;
  }

  .leaflet-oldie .leaflet-control-zoom,
  .leaflet-oldie .leaflet-control-layers,
  .leaflet-oldie .leaflet-popup-content-wrapper,
  .leaflet-oldie .leaflet-popup-tip {
    border: 1px solid #999;
  }

  /* div icon */

  .leaflet-div-icon {
    background: #fff;
    border: 1px solid #666;
  }

  /* Tooltip */
  /* Base styles for the element that has a tooltip */
  .leaflet-tooltip {
    position: absolute;
    padding: 6px;
    background-color: #fff;
    border: 1px solid #fff;
    border-radius: 3px;
    color: #222;
    white-space: nowrap;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    pointer-events: none;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.4);
  }
  .leaflet-tooltip.leaflet-clickable {
    cursor: pointer;
    pointer-events: auto;
  }
  .leaflet-tooltip-top:before,
  .leaflet-tooltip-bottom:before,
  .leaflet-tooltip-left:before,
  .leaflet-tooltip-right:before {
    position: absolute;
    pointer-events: none;
    border: 6px solid transparent;
    background: transparent;
    content: "";
  }

  /* Directions */

  .leaflet-tooltip-bottom {
    margin-top: 6px;
  }
  .leaflet-tooltip-top {
    margin-top: -6px;
  }
  .leaflet-tooltip-bottom:before,
  .leaflet-tooltip-top:before {
    left: 50%;
    margin-left: -6px;
  }
  .leaflet-tooltip-top:before {
    bottom: 0;
    margin-bottom: -12px;
    border-top-color: #fff;
  }
  .leaflet-tooltip-bottom:before {
    top: 0;
    margin-top: -12px;
    margin-left: -6px;
    border-bottom-color: #fff;
  }
  .leaflet-tooltip-left {
    margin-left: -6px;
  }
  .leaflet-tooltip-right {
    margin-left: 6px;
  }
  .leaflet-tooltip-left:before,
  .leaflet-tooltip-right:before {
    top: 50%;
    margin-top: -6px;
  }
  .leaflet-tooltip-left:before {
    right: 0;
    margin-right: -12px;
    border-left-color: #fff;
  }
  .leaflet-tooltip-right:before {
    left: 0;
    margin-left: -12px;
    border-right-color: #fff;
  }

  /* Component styling */

  width: 100%;
  height: 100%;

  #map {
    width: 100%;
    height: 100%;
  }
`;

//FETCH DATA HERE
const QUERY = gql`
  query {
    imageDemos {
      values {
        lat
        lon
        value
      }
    }
  }
`;

const SUBSCRIPTION = gql`
  subscription newImageDemos {
    newImageDemos {
      values {
        lat
        lon
        value
      }
    }
  }
`;

export interface MapViewProps {}

const MapView: React.FC<MapViewProps> = () => {
  const ref = useRef<HTMLDivElement>(null);
  const [data, setData] = useState<HeatmapValue[]>();
  const [map, setMap] = useState<L.Map>();
  const [res] = useSubscription(
    { query: SUBSCRIPTION },
    (messages = [], response) => {
      //   console.log(response.newImageDemos.values);
      // setData(response.newImageDemos.values);
    }
  );

  //   const [res] = useQuery({
  //     query: QUERY,
  //   });
  //   if (res.fetching) {
  //     console.log("Loading...");
  //   } else if (res.error) {
  //     console.log(res.error);
  //   }

  //Fetch the data from backend
  useEffect(() => {
    // console.log(res.data);
    if (ref.current) {
      const map = drawMap(ref.current);
      if (map) loadHeatmapValues(map, SAMPLE_HEAT_DATA);
    }
  }, []);
  useEffect(() => {}, []);

  return (
    <>
      <StyledSection>
        <div id="map" ref={ref}></div>
      </StyledSection>
    </>
  );
};

export default MapView;
